export default __webpack_public_path__ + "static/media/search-dnd-icon.1b9e952f.svg";